import React, { useState } from "react";
import "./App.css";
import {
  createRoutesFromElements,
  createBrowserRouter,
  RouterProvider,
  Route,
} from "react-router-dom";
import Layout from "./pages/layouts/Layout";

import { AuthProvider } from "./components/context/context";


import Error from "./Error";
import Home from "./pages/home/Home";
import PageNotFound from "./pages/error/PageNotFound";
import Download from "./pages/download/Dowlnoad";
import Notification from "./pages/notifications/Notification";
import PublicHearing from "./pages/public_hearing/PublicHearing";
import Gallery from "./pages/gallery/Gallery";
import FAQ from "./pages/faq/FAQ";
import Contact from "./pages/contact/Contact";
import AboutUs from "./pages/about/AboutUs";
import Training from "./pages/training/Training";
import Block from "./pages/block/Block";
import District from "./pages/district/District";
import Area from "./pages/area/Area";
import AnualReport from "./pages/anualReport/AnualReport";
import NewsLetter from "./pages/NewsLetter/NewsLetter";
import Recruitments from "./pages/recruitments/Recruitments";
import Tenders from "./pages/tenders/Tenders";
import ContactDetails from "./pages/contactDetails/ContactDetails";
import SocialAuditResourcePersons from "./pages/socialAudit/SocialAuditResourcePersons";
import SocialAuditReport from "./pages/socialAudit/SocialAudtiReport";
import GoverningBody from "./pages/governingBody/GoverningBody";
import SiteMap from "./pages/siteMap/SiteMap";
import TermsOfUse from "./pages/termsOfUse/TermsOfUse";
import Accessibility from "./pages/access/Accessibility";
import Help from "./pages/help/Help";

const router = createBrowserRouter(
  createRoutesFromElements(

    <Route path="/" element={<Layout />} errorElement={<Error />}>
      <Route index element={<Home />}></Route>
      <Route path="download" element={<Download />}></Route>
      <Route path="notifications" element={<Notification />}></Route>
      <Route path="public_hearing" element={<PublicHearing />}></Route>
      <Route path="photo-gallery" element={<Gallery />}></Route>
      <Route path="faq" element={<FAQ />}></Route>
      <Route path="contact_us" element={<Contact />}></Route>
      <Route path="about-us" element={<AboutUs />}></Route>
      <Route path="training" element={<Training />}></Route>
      <Route path="district" element={<District />}></Route>
      <Route path="block" element={<Block />}></Route>
      <Route path="area-village" element={<Area />}></Route>
      <Route path="annual-report" element={<AnualReport />}></Route>
      <Route path="news-letter" element={<NewsLetter />}></Route>
      <Route path="recruitments" element={<Recruitments />}></Route>
      <Route path="tenders" element={<Tenders />}></Route>
      <Route path="contact-details" element={<ContactDetails />}></Route>
      <Route path="social-audit" element={<SocialAuditResourcePersons />}></Route>
      <Route path="audit-report" element={<SocialAuditReport />}></Route>
      <Route path="governing-body" element={<GoverningBody />}></Route>
      <Route path="sitemap" element={<SiteMap />}></Route>
      <Route path="terms-of-use" element={<TermsOfUse />}></Route>
      <Route path="statement" element={<Accessibility />}></Route>
      <Route path="help" element={<Help />}></Route>
      <Route path="*" element={<PageNotFound />} ></Route>
    </Route>

  )
);
const App = () => {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
};

export default App;
